import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let pending = null;

export function fetchSiteContent(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (pending && !force) return pending;
  pending = api.get("/config/site-content")
    .then(({ data }) => { cache = data; pending = null; return data; })
    .catch(() => { pending = null; return cache || {}; });
  return pending;
}

export function refreshSiteContent() {
  return fetchSiteContent(true);
}

export function useSiteContent() {
  const [content, setContent] = useState(cache || {});
  useEffect(() => { fetchSiteContent().then(setContent); }, []);
  return content;
}
